export default __webpack_public_path__ + "static/media/cl22.790b6936.webp";